import type { ReactNode } from 'react';

/**
 * Sello de estado de las vistas de Revisión de hallazgos. Un solo estilo (`.admin-chip`) con el
 * color semántico del admin: solo el estado lleva color; las categorías van en neutro.
 */
export type TonoSello = 'neutro' | 'pendiente' | 'ok' | 'alerta';

const TONOS: Record<TonoSello, string> = {
  neutro: 'bg-(--admin-surface2) text-(--admin-text2)',
  pendiente: 'bg-(--admin-amber-bg) text-(--admin-amber)',
  ok: 'bg-(--admin-green-bg) text-(--admin-green)',
  alerta: 'bg-(--admin-red-bg) text-(--admin-red)',
};

export function Sello({ tono = 'neutro', children }: { tono?: TonoSello; children: ReactNode }) {
  return <span className={`admin-chip ${TONOS[tono]}`}>{children}</span>;
}

const ESTADOS_AUDIO: Record<string, string> = {
  ACTIVO: 'Activo',
  APROBADO: 'Aprobado',
  PENDIENTE: 'Pendiente',
  RECHAZADO: 'Rechazado',
  ELIMINADO: 'Eliminado',
};

/** Estado del audio con su nombre legible (los códigos de la BD vienen en mayúsculas). */
export const estadoAudio = (estado: string) => ESTADOS_AUDIO[estado] ?? estado.charAt(0) + estado.slice(1).toLowerCase();
